module.exports = __webpack_public_path__ + "img/Maldives.7c92fec6.gif";